import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { EventManagerService } from 'src/app/core/services/event-manager.service';
import { WarningBannerDialogComponent } from 'src/app/shared/components/warning-banner-dialog/warning-banner-dialog.component';
import { ProfileService } from 'src/app/shared/service/profile.service';
interface Window {
  _bcvma: any;
  bcLoaded: any;
  pageViewer: any;
  attachEvent: any;
  addEventListener: any;
}

@Component({
  selector: 'app-application-catalog',
  templateUrl: './application-catalog.component.html',
  styleUrls: ['./application-catalog.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '(window:resize)': 'onWindowResize($event)'
  }
})
export class ApplicationCatalogComponent implements OnInit {
  isShow = true;
  isMobile = false;
  width: number = window.innerWidth;
  mobileWidth = 760;
  userName: string;
  selectedItem = 'Clear Orbit';
  // supplierList = ['Clear Orbit', 'OTM', 'Quality Suite', 'RACES iSupplier', 'RenTM', 'RenTT', 'Corella Collaboration & Qualifications',
  // 'OSCAR', 'Intelex Supplier Audit', 'Supplier Portal / ScoreCard', 'GE ID Tag Request']; //GESCTASK8524659
  supplierList = ['OTM', 'Quality Suite', 'RACES iSupplier', 'RenTM', 'RenTT', 'Corella Collaboration & Qualifications',
    'OSCAR', 'Supplier Portal / ScoreCard', 'GE ID Tag Request'];
  selectedIndexTab = 0;
  constructor(
    private eventManager: EventManagerService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private service: ProfileService,
    private dialog: MatDialog) {
    activeRoute.queryParams
      .subscribe((params) => {
        this.selectedItem = params.item ? params.item : this.selectedItem;
        this.selectedIndexTab = params.selectedIndexTab ? params.selectedIndexTab : 0;
      });
  }

  ngOnInit(): void {
    this.userName = decodeURIComponent(escape(atob(localStorage.getItem(btoa('userName')))));
    if (atob(sessionStorage.getItem(btoa('showBanner'))) === 'true' && this.userName) {
      const dialogRef = this.dialog.open(WarningBannerDialogComponent, {
        width: '500px',
        maxHeight: '600px',
        disableClose: true
      });
    }
    this.eventManager.subscribe('SHOW_SIDEBAR', (res) => {
      this.isShow = res.data.isShow;
    });
    this.isMobile = this.width < this.mobileWidth;
    if(this.selectedIndexTab != 1) {
      this.onClick(this.selectedItem);
    }
  }

  onWindowResize(event) {
    this.width = event.target.innerWidth;
    this.isMobile = this.width < this.mobileWidth;
    if (this.width < this.mobileWidth) {
      this.isShow = true;
    }
  }

  onClick(item): void {
    this.selectedItem = item;
    this.router.navigate(['/application-catalog'], { queryParams: { item: this.selectedItem } });
  }

}
